<template>
    <div class="left-sidebar-layout">
        <aside
            v-if="!hideSidebar"
            class="d-lg-none"
        >
            <slot name="mobile-sidebar" />
        </aside>

        <b-container>
            <mobile-gutter>
                <b-row>
                    <b-col
                        v-if="!hideSidebar"
                        lg="3"
                        xl="2"
                    >
                        <aside class="sidebar d-none d-lg-block">
                            <slot name="desktop-sidebar" />
                        </aside>
                    </b-col>

                    <b-col
                        :lg="hideSidebar ? 12 : 9"
                        :xl="hideSidebar ? 12 : 10"
                    >
                        <div class="primary-content">
                            <div class="primary-content-inner">
                                <slot name="primary-content" />
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </mobile-gutter>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: 'left-sidebar-layout',

        props: {
            hideSidebar: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep {
        @import "~bootstrap/scss/utilities/display";
    }

    .left-sidebar-layout {
        padding-top: 17px;
        overflow: hidden;
        background-color: $white;

        @include media-breakpoint-up(lg) {
            background-color: secondary-palette(7);
            padding: 25px 0 60px;
        }
    }

    .row {
        @include media-breakpoint-up(lg) {
            min-height: 600px;
        }
    }

    .sidebar {
        padding-right: 30px;
        padding-top: 60px;
        position: relative;

        @include media-breakpoint-up(xl) {
            padding-right: 0;
        }
    }

    .primary-content {
        @include media-breakpoint-up(lg) {
            min-height: 100%;
            background-color: $white;
            border-top-left-radius: 100px;
            border-bottom-left-radius: 100px;
            padding: 35px 0 35px 65px;
        }

        @include media-breakpoint-up(xl) {
            padding-left: 85px;
            padding-bottom: 130px;
        }

        &::before {
            @include media-breakpoint-up(lg) {
                content: '';
                position: absolute;
                top: 0;
                bottom: 0;
                left: 200px;
                width: 100vw;
                background-color: inherit;
            }
        }
    }

    .primary-content-inner {
        @include media-breakpoint-up(lg) {
            z-index: 1;
            position: relative;
        }
    }
</style>
